module.exports = __webpack_public_path__ + "static/img/xiandaifuwu-3.3169b1cc.svg";